/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import styled, { createGlobalStyle, css } from 'styled-components';
import { Checkbox, Table, Tooltip, Space, Switch } from 'antd';
import {
  theme,
  CardAnt,
  ButtonAnt
} from '@pfmam/pfmam';
import { Container } from '../../styles/globalStyle';
import { useSelector } from 'react-redux';
import NoDataFound from '../../common/components/noDataFound';
import { InfoCircleOutlined } from '@ant-design/icons';



const TableWrapper = styled.div`
  .ant-table-title {
    padding: 0 !important;
  }
  .table-primary .ant-table-thead > tr > th {
    font-family: 'Inter';
    font-weight: bold;
    text-align: center;
    border: 1px solid ${theme.colors.grey};
  }
  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
    background-color: ${theme.colors.transparent};
  }
  .ant-table-tbody > tr > td:not(:first-child) {
    text-align: center;
  }

  .ant-table-tbody > tr > td {
        border: 1px solid ${theme.colors.grey};
  }

  .ant-table .ant-table-tbody > tr > td {
  padding: 30px;
  }

  .ant-table-thead > tr > th, .ant-table-tbody > tr > td, .ant-table tfoot > tr > th, .ant-table tfoot > tr > td {
    padding: 12px 4px;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${(props) => props.linkTextColor};
    border-color: ${(props) => props.linkTextColor};
  }
  

  .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: white; /* Ensure the tick mark is visible */
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
   /* border-color: #1890ff; */
   border-color: ${(props) => props.linkTextColor} !important;
  }

  .ant-table.ant-table-middle
    .ant-table-tbody
    .ant-table-wrapper:only-child
    import {
      theme,
    
      .ant-table-row-expand-icon {
        line-height: 32px;
        &:focus,
        &:hover {
          color: ${theme.colors.blue_primay};
          border-color: ${theme.colors.blue_primay};
        }
      }
      cursor: pointer;
    }
    .ant-table-tbody,
    .ant-table-expanded-row {
      .ant-table-row {
        cursor: default;
      }
    }
  }
  .link {
    &:hover {
      opacity: 0.6;
    }
    &:focus,
    &:active {
      opacity: 1;
    }
  }
`;



const RenderCreateContactPermissionForm = (props) => {
  const { formValues, setFormValues } = props;

  const primary_color = useSelector((state) => state.siteInfo.primaryColor);
  const connectLoggedInContactId = useSelector((state) => state.userSlice.user.profile.sub);

  const programId = useSelector((state) => state.programsClientsSlice.selectedClient.payload[0].programid);



  const handleCheckboxChange = (e, row, type) => {
    //setIsTouched(true);
    const newData = [...formValues.accountTeamMembers];
    const index = newData.findIndex((item) => row.key === item.key);
    if (index > -1) {

      const item = newData[index];

      if (type === 'IsViewReports') {
        if (!e.target.checked) {
          newData[index] = { ...item, IsViewReports: e.target.checked ? 1 : 0, IsEnterTransactions: 0, IsModifyBankingInstructions: 0, IsCloseAccounts: 0, IsManageUsers: 0, IsCheckVerifier: 0 }
        } else
          newData[index] = { ...item, IsViewReports: e.target.checked ? 1 : 0 }
      } else if (type === 'IsEnterTransactions') {
        newData[index] = { ...item, IsEnterTransactions: e.target.checked ? 1 : 0 }
      } else if (type === 'IsModifyBankingInstructions') {
        newData[index] = { ...item, IsModifyBankingInstructions: e.target.checked ? 1 : 0 }
      } else if (type === 'IsCloseAccounts') {
        newData[index] = { ...item, IsCloseAccounts: e.target.checked ? 1 : 0 }
      } else if (type === 'IsManageUsers') {
        newData[index] = { ...item, IsManageUsers: e.target.checked ? 1 : 0 }
      }
      else if (type === 'IsStatementRecipient') {
        newData[index] = { ...item, IsStatementRecipient: e.target.checked ? 1 : 0 }
      }
      else if (type === 'IsCheckVerifier') {
        newData[index] = { ...item, IsCheckVerifier: e.target.checked ? 1 : 0 }
      }

      setFormValues((prevValues) => ({
        ...prevValues,
        accountTeamMembers: newData,
      }));
    }
  };

  const handleSelectAllChange = (e, type) => {
    const newData = formValues.accountTeamMembers?.map((item) => {
      // Exclude the row of logged in contact from being updated when "View Reports", "Close Accounts" or "Manage Users" is toggled
      if ((type === 'IsViewReports' || type === "IsCloseAccounts" || type === "IsManageUsers") && item.ContactId == connectLoggedInContactId) {
        return item; // Keep the row unchanged
      }

      if (type === 'IsViewReports') {
        return {
          ...item,
          IsViewReports: e.target.checked,
          IsEnterTransactions: e.target.checked ? item.IsEnterTransactions : false,
          IsModifyBankingInstructions: e.target.checked ? item.IsModifyBankingInstructions : false,
          IsCloseAccounts: e.target.checked ? item.IsCloseAccounts : false,
          IsManageUsers: e.target.checked ? item.IsManageUsers : false,
          IsCheckVerifier: e.target.checked ? item.IsCheckVerifier : false,
        };
      } else {
        return {
          ...item,
          [type]: e.target.checked,
        };
      }
    });
    setFormValues((prevValues) => ({
      ...prevValues,
      accountTeamMembers: newData,
    }));
  };

  const poolColumns = [
    {
      title: (
        <div style={{ textAlign: 'center' }}>
          <span>Account</span>
        </div>
      ),
      dataIndex: 'DisplayName',
      render: (_, record) => (
        <div>
          <div>{record.DisplayName}</div>
          <div style={{ fontSize: '12px', color: 'gray' }}>{record.EmailAddress}</div>
        </div>
      ),
    },
    {
      title: (
        <div style={{ textAlign: 'center' }}>
          <Tooltip
            placement="top"
            title="View account Information"
            overlayClassName="tooltip"
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <span>View</span>
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                Reports
              </span>
              <span>
                <InfoCircleOutlined style={{ marginLeft: 4, cursor: 'pointer', verticalAlign: 'middle' }} />
              </span>
            </div>

          </Tooltip>
          <Checkbox
            style={{ marginTop: 8 }}
            onChange={(e) => handleSelectAllChange(e, 'IsViewReports')}
            checked={formValues.accountTeamMembers?.every((item) => item.IsViewReports)}
            indeterminate={
              formValues.accountTeamMembers?.some((item) => item.IsViewReports) &&
              !formValues.accountTeamMembers?.every((item) => item.IsViewReports)
            }
          />
        </div>
      ),
      dataIndex: 'IsViewReports',
      render: (_, record) => (
        <Checkbox
          disabled={record.ContactId == connectLoggedInContactId}
          checked={record.IsViewReports}
          onChange={(e) => handleCheckboxChange(e, record, 'IsViewReports')}
        />
      ),
    },
    {
      title: (
        <div style={{ textAlign: 'center' }}>
          <Tooltip
            placement="top"
            title="Initiate transactions to/from instructions on file"
            overlayClassName="tooltip"
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <span>Enter</span>
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                Transactions
              </span>
              <span>
                <InfoCircleOutlined style={{ marginLeft: 4, cursor: 'pointer', verticalAlign: 'middle' }} />
              </span>
            </div>
          </Tooltip>
          <Checkbox
            style={{ marginTop: 8 }}
            onChange={(e) => handleSelectAllChange(e, 'IsEnterTransactions')}
            checked={formValues.accountTeamMembers?.every((item) => item.IsEnterTransactions)}
            indeterminate={
              formValues.accountTeamMembers?.some((item) => item.IsEnterTransactions) &&
              !formValues.accountTeamMembers?.every((item) => item.IsEnterTransactions)
            }
            disabled={!formValues.accountTeamMembers?.every((item) => item.IsViewReports)}
          />
        </div>
      ),
      dataIndex: 'IsEnterTransactions',
      render: (_, record) => (
        <Checkbox
          disabled={!record.IsViewReports}
          checked={record.IsEnterTransactions}
          onChange={(e) => handleCheckboxChange(e, record, 'IsEnterTransactions')}
        />
      ),
    },
    {
      title: (
        <div style={{ textAlign: 'center' }}>
          <Tooltip
            placement="top"
            title="Add/remove banking instructions"
            overlayClassName="tooltip"
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <span>Modify</span>
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                Banking Instructions
              </span>
              <span>
                <InfoCircleOutlined style={{ marginLeft: 4, cursor: 'pointer', verticalAlign: 'middle' }} />
              </span>
            </div>
          </Tooltip>
          <Checkbox
            style={{ marginTop: 8 }}
            onChange={(e) => handleSelectAllChange(e, 'IsModifyBankingInstructions')}
            checked={formValues.accountTeamMembers?.every((item) => item.IsModifyBankingInstructions)}
            indeterminate={
              formValues.accountTeamMembers?.some((item) => item.IsModifyBankingInstructions) &&
              !formValues.accountTeamMembers?.every((item) => item.IsModifyBankingInstructions)
            }
            disabled={!formValues.accountTeamMembers?.every((item) => item.IsViewReports)}
          />
        </div>
      ),
      dataIndex: 'IsModifyBankingInstructions',
      render: (_, record) => (
        <Checkbox
          disabled={!record.IsViewReports}
          checked={record.IsModifyBankingInstructions}
          onChange={(e) => handleCheckboxChange(e, record, 'IsModifyBankingInstructions')}
        />
      ),
    },
    {
      title: (
        <div style={{ textAlign: 'center' }}>
          <Tooltip
            placement="top"
            title="Open and close accounts"
            overlayClassName="tooltip"
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <span>Close</span>
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                Accounts
              </span>
              <span>
                <InfoCircleOutlined style={{ marginLeft: 4, cursor: 'pointer', verticalAlign: 'middle' }} />
              </span>
            </div>
          </Tooltip>
          <Checkbox
            style={{ marginTop: 8 }}
            onChange={(e) => handleSelectAllChange(e, 'IsCloseAccounts')}
            checked={formValues.accountTeamMembers?.every((item) => item.IsCloseAccounts)}
            indeterminate={
              formValues.accountTeamMembers?.some((item) => item.IsCloseAccounts) &&
              !formValues.accountTeamMembers?.every((item) => item.IsCloseAccounts)
            }
            disabled={!formValues.accountTeamMembers?.every((item) => item.IsViewReports)}
          />
        </div>
      ),
      dataIndex: 'IsCloseAccounts',
      render: (_, record) => (
        <Checkbox
          disabled={record.ContactId == connectLoggedInContactId ? true : !record.IsViewReports}
          checked={record.IsCloseAccounts}
          onChange={(e) => handleCheckboxChange(e, record, 'IsCloseAccounts')}
        />
      ),
    },
    {
      title: (
        <div style={{ textAlign: 'center' }}>
          <Tooltip
            placement="top"
            title="Add/remove permissions to/from contacts"
            overlayClassName="tooltip"
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <span>Manage</span>
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                Users
              </span>
              <span>
                <InfoCircleOutlined style={{ marginLeft: 4, cursor: 'pointer', verticalAlign: 'middle' }} />
              </span>
            </div>
          </Tooltip>
          <Checkbox
            style={{ marginTop: 8 }}
            onChange={(e) => handleSelectAllChange(e, 'IsManageUsers')}
            checked={formValues.accountTeamMembers?.every((item) => item.IsManageUsers)}
            indeterminate={
              formValues.accountTeamMembers?.some((item) => item.IsManageUsers) &&
              !formValues.accountTeamMembers?.every((item) => item.IsManageUsers)
            }
            disabled={!formValues.accountTeamMembers?.every((item) => item.IsViewReports)}
          />
        </div>
      ),
      dataIndex: 'IsManageUsers',
      render: (_, record) => (
        <Checkbox
          disabled={record.ContactId == connectLoggedInContactId ? true : !record.IsViewReports}
          checked={record.IsManageUsers}
          onChange={(e) => handleCheckboxChange(e, record, 'IsManageUsers')}
        />
      ),
    },
    {
      title: (
        <div style={{ textAlign: 'center' }}>
          <Tooltip
            placement="top"
            title="Add/remove user from statement recipients list"
            overlayClassName="tooltip"
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <span>Statement</span>
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                Recipient
              </span>
              <span>
                <InfoCircleOutlined style={{ marginLeft: 4, cursor: 'pointer', verticalAlign: 'middle' }} />
              </span>
            </div>
          </Tooltip>
          <Checkbox
            style={{ marginTop: 8 }}
            onChange={(e) => handleSelectAllChange(e, 'IsStatementRecipient')}
            checked={formValues.accountTeamMembers?.every((item) => item.IsStatementRecipient)}
            indeterminate={
              formValues.accountTeamMembers?.some((item) => item.IsStatementRecipient) &&
              !formValues.accountTeamMembers?.every((item) => item.IsStatementRecipient)
            }
            disabled={!formValues.accountTeamMembers?.every((item) => item.IsViewReports)}
          />
        </div>
      ),
      dataIndex: 'IsStatementRecipient',
      render: (_, record) => (
        <Checkbox
          //  disabled={record.ContactId == connectLoggedInContactId ? true : !record.IsViewReports}
          disabled={false}
          checked={record.IsStatementRecipient}
          onChange={(e) => handleCheckboxChange(e, record, 'IsStatementRecipient')}
        />
      ),
    },


  ];

  if (programId === 44) {
    poolColumns.push(
      {
        title: (
          <div style={{ textAlign: 'center' }}>
            <Tooltip
              placement="top"
              title="Check verifiers will be responsible for reviewing check activity on the PLGIT account(s) each business day and contacting PLGIT in a timely manner if payment needs to be stopped."
              overlayClassName="tooltip"
            >
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <span>Check</span>
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  Verifier
                </span>
                <span>
                  <InfoCircleOutlined style={{ marginLeft: 4, cursor: 'pointer', verticalAlign: 'middle' }} />
                </span>
              </div>
            </Tooltip>
            <Checkbox
              style={{ marginTop: 8 }}
              onChange={(e) => handleSelectAllChange(e, 'IsCheckVerifier')}
              checked={formValues.accountTeamMembers?.every((item) => item.IsCheckVerifier)}
              indeterminate={
                formValues.accountTeamMembers?.some((item) => item.IsCheckVerifier) &&
                !formValues.accountTeamMembers?.every((item) => item.IsCheckVerifier)
              }
              disabled={!formValues.accountTeamMembers?.every((item) => item.IsViewReports)}
            />
          </div>
        ),
        dataIndex: 'IsCheckVerifier',
        render: (_, record) => (
          <Checkbox
            disabled={!record.IsViewReports}
            checked={record.IsCheckVerifier}
            onChange={(e) => handleCheckboxChange(e, record, 'IsCheckVerifier')}
          />
        ),
      }
    );
  }



  return (
    <>
      <TableWrapper linkTextColor={primary_color}>
        <Table
          className="table-primary"
          dataSource={formValues.accountTeamMembers}
          columns={poolColumns}
          pagination={false}
          locale={{
            emptyText: <NoDataFound text="No Accounts found" padding="12px 0" />,
          }}
        />
      </TableWrapper>
      <br></br>
    </>
  );
};


const TeamMembersAccountPermissionsComponent = (props) => {
  const { formValues, setFormValues } = props;
  return (
    <RenderCreateContactPermissionForm
      formValues={formValues}
      setFormValues={setFormValues}
    />
  );
};

export default TeamMembersAccountPermissionsComponent;
